import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";

export const RouteContext = createContext<{
  reloadRoute: () => void;
}>({
  reloadRoute: () => {},
});

const Layout = () => {
  const { pathname } = useLocation();
  const [showRoute, setShowRoute] = useState(true);

  const reloadRoute = () => {
    window.scrollTo(0, 0);
    setShowRoute(false);
  };

  useEffect(() => {
    if (!showRoute) setShowRoute(true);
  }, [showRoute]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Box>
      <RouteContext.Provider value={{ reloadRoute: reloadRoute }}>
        {showRoute && <Outlet />}
      </RouteContext.Provider>
    </Box>
  );
};

export default Layout;
